// src/components/auth/RequireAdminRole.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const RequireAdminRole = ({ children, user, loading }) => {
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const role = user.role?.toLowerCase() || '';
  const isAdmin = ['admin', 'super admin', 'superadmin'].includes(role);

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6 text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Access Denied</h1>
        <p className="mb-4">You do not have permission to access this page.</p>
        <p className="text-sm text-gray-600">Your role: <strong>{user.role || 'Unknown'}</strong></p>
        <button
          onClick={() => window.history.back()}
          className="mt-6 px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
        >
          Go Back
        </button>
      </div>
    );
  }

  return children;
};

export default RequireAdminRole;
